export default "__VITE_ASSET__536d7eac__"